export default __webpack_public_path__ + "static/media/avatar.35e53bb3.png";